import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { AreaModel } from '../models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AreaService {
  constructor(private apiService: ApiService) {}

  add(area: any): Observable<any> {
    return this.apiService.post(`/area`, { area }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getAll(limit?: number): Observable<any[]> {
    const path = limit ? `/areas/?limit=${limit}` : `/areas`;
    return this.apiService.get(path);
  }

  getById(id: string): Observable<any> {
    return this.apiService.get(`/areas/${id}`);
  }

  update(area: any): Observable<any> {
    const { id } = area;
    return this.apiService.put(`/areas/${id}`, area).pipe(
      map((data) => {
        return data;
      })
    );
  }

  delete(id: string) {
    return this.apiService.delete(`/areas/${id}`).pipe(
      map((data) => {
        return data;
      })
    );
  }
}
